import { Fragment, type ReactNode } from 'react';

/**
 * A translated sentence with styled values (2026-09-26). Each `{name}` of the
 * template becomes the node in `parts.name`, so a bold name keeps its place
 * in the word order of each language: "You're {name}. Send a request to join
 * {team} as athlete." and "Jūs esate {name}. Išsiųskite prašymą prisijungti
 * prie {team} kaip sportininkas." A placeholder with no part stays as text.
 */
export function richText(template: string, parts: Record<string, ReactNode>): ReactNode {
  return template.split(/(\{\w+\})/g).map((piece, i) => {
    const key = /^\{(\w+)\}$/.exec(piece)?.[1];
    return <Fragment key={i}>{key !== undefined && key in parts ? parts[key] : piece}</Fragment>;
  });
}
